// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__tzBq4","questions":"styles_questions__vORrX","footer":"styles_footer__QYtyW"};